import { container, title } from 'assets/jss/material-kit-react.js'

const indexPageStyle = {
  container: {
    zIndex: '12',
    color: '#FFFFFF',
    ...container,
  },
  title: {
    ...title,
    display: 'inline-block',
    position: 'relative',
    marginTop: '30px',
    minHeight: '32px',
    color: '#FFFFFF',
    textDecoration: 'none',
  },
  subtitle: {
    ...title,
    display: 'inline-block',
    position: 'relative',
    marginTop: '-15px',
    color: '#FFFFFF',
    textDecoration: 'none',
    fontSize: '1.8rem',
    // maxWidth: '500px',
    // margin: '10px auto 0',
  },
  navButton: {
    color: 'inherit',
    '&:hover,&:focus': {
      color: 'inherit',
    },
  },
  main: {
    background: '#FFFFFF',
    position: 'relative',
    zIndex: '3',
  },
  mainRaised: {
    margin: '-60px 30px 0px',
    borderRadius: '6px',
    boxShadow: '0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)',
    '@media (max-width: 830px)': {
      'margin-left': '10px',
      'margin-right': '10px',
    },
    '@media (max-width: 576px)': {
      'margin-top': '-30px',
    },
  },
}

export default indexPageStyle
